// Lockup Amine (roue + plaque AMINE TAXI) — port de docs/design/tokens.jsx.
// Couleurs via variables CSS (thème-aware Classique/Nuit).

const AMINE_RED = '#E2231A'

function Wheel({ r }: { r: number }) {
  const n = 22
  const w = r * 0.12
  const teeth = Array.from({ length: n }, (_, i) => (
    <rect
      key={i}
      x={-w / 2}
      y={-r * 1.04}
      width={w}
      height={r * 0.5}
      rx={r * 0.02}
      transform={`rotate(${(360 / n) * i})`}
      fill={AMINE_RED}
    />
  ))
  return (
    <g>
      <circle r={r} fill="var(--ink)" />
      {teeth}
      <circle r={r * 0.56} fill="var(--ink)" />
      <circle r={r * 0.48} fill="var(--primary)" />
      <g fill="none" stroke="var(--ink)" strokeLinecap="round" strokeLinejoin="round">
        <path
          d={`M ${-r * 0.27} ${r * 0.32} L 0 ${-r * 0.34} L ${r * 0.27} ${r * 0.32}`}
          strokeWidth={r * 0.13}
        />
        <path d={`M ${-r * 0.15} ${r * 0.02} L ${r * 0.15} ${r * 0.02}`} strokeWidth={r * 0.1} />
      </g>
      <circle cx={0} cy={-r * 0.4} r={r * 0.08} fill={AMINE_RED} />
    </g>
  )
}

export function AmineLockup({ height = 34 }: { height?: number }) {
  const w = height * (150 / 56)
  return (
    <svg width={w} height={height} viewBox="0 0 150 56" className="block">
      <g transform="translate(27,28)">
        <Wheel r={25} />
      </g>
      <g>
        <rect x={60} y={8} width={84} height={40} rx={8} fill="var(--ink)" />
        <rect
          x={60}
          y={8}
          width={84}
          height={40}
          rx={8}
          fill="none"
          stroke="var(--primary)"
          strokeWidth={2.4}
        />
        <text
          x="102"
          y="31"
          textAnchor="middle"
          fontFamily="Space Grotesk, system-ui"
          fontWeight="700"
          fontSize="20"
          fill="var(--primary)"
          letterSpacing="2"
        >
          AMINE
        </text>
        <rect x={74} y={36} width={56} height={1.4} fill="var(--primary)" opacity={0.5} />
        <text
          x="102"
          y="45"
          textAnchor="middle"
          fontFamily="Outfit, system-ui"
          fontWeight="600"
          fontSize="8"
          fill="var(--surface)"
          letterSpacing="5"
          opacity={0.9}
        >
          TAXI
        </text>
      </g>
    </svg>
  )
}
